
<template>
  <v-container fluid>
    <v-card class="d-flex pb-2 flex-column elevation-6 rounded-tl-xl">
      <v-card-title class="red darken-1 white--text justify-center">
        <v-col cols="12" class="pa-0 ma-0 d-flex justify-start">
          <v-btn icon color="blue-grey darken-1" :to="{name: 'SellerPage'}"><v-icon color="white">mdi-arrow-left</v-icon></v-btn>
        </v-col>
        <v-col cols="12" class="pa-0 ma-0 d-flex flex-column justify-center align-center">
          <div >
            <v-icon class="mr-2 white--text" large>mdi-store</v-icon>
            Relatório de Vendas
          </div>
        </v-col>
        <v-col cols="12">
          <v-row justify="center">
            <div class="d-flex flex-column">
              <div class="text-h4 font-weight-bold text-center white--text text--darken-2 mb-6">
                {{ actual_month }}
              </div>
              <div class="d-flex">
                <v-btn width="120px" small @click="monthGoBack" class="mx-2" :disabled="back_btn_disabled" color="white">
                  <v-icon small class="mr-2">mdi-chevron-left</v-icon>
                  Voltar
                </v-btn>

                <v-btn width="120px" small @click="monthGoNext" class="mx-2" :disabled="next_btn_disabled" color="white">
                  Avançar
                  <v-icon small class="ml-2">mdi-chevron-right</v-icon>
                </v-btn>
              </div>
            </div>
          </v-row>
        </v-col>
        
      </v-card-title>
      <v-card-text>
        <DirectorSelectSeller @update="handleSelectedEmployee"></DirectorSelectSeller>
        <v-data-table :loading="all_loadings" :headers="headers" :items="data" hide-default-footer :items-per-page="-1">
          <template v-slot:no-data>
            <v-sheet width="100%" class="pa-5" v-if="!employee_id">
              <v-icon left>mdi-account</v-icon>
              <span> Selecione um Vendedor</span>
            </v-sheet>
            <v-sheet width="100%" v-if="employee_id">
              <span> Não há dados disponíveis</span>
            </v-sheet>
          </template>
          <template v-for="modality in modalities" v-slot:[`item.${modality.id}`]="{item}">
            <div v-if="item[modality.id] != 0" class="d-flex justify-center align-center">
              <span>{{ Number(item[modality.id]).toFixed(2) }}</span>
            </div>
            <span v-else class="d-flex justify-center align-center grey--text">-</span>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import Api from '@/api/index'

export default {
  name: 'DoneOrdersByModality',
  components: {
    DirectorSelectSeller: () => import('@/components/seller/shared/DirectorSelectSeller.vue'),
  },
  data() {
    return {
      month_off_set: 0,
      headers: [],
      data: [],
      modalities: [],
      seller_dashboard:[],
      employee_id: null,
      loading: {
        modalities: false,
        dashboard:false,
      }
    }
  },
  computed:{
    all_loadings(){
      return Object.values(this.loading).some(valor => valor == true);
    },
    actual_month() {
      const data = new Date();
      data.setMonth(data.getMonth() - this.month_off_set);
      const month_name = data.toLocaleDateString('pt-BR', { month: 'long' });
      return month_name.toUpperCase();
    },
    back_btn_disabled() {
      return this.month_off_set >= 2;
    },
    next_btn_disabled() {
      return this.month_off_set <= 0;
    },
  },
  methods: {
    getData(){
      if(this.employee_id){
        this.data = []
        this.getModalities()
        this.getDashboard()
      }
    },
    monthGoBack() {
      if (!this.back_btn_disabled) {
        this.month_off_set++;
      }
    },
    monthGoNext() {
      if (!this.next_btn_disabled) {
        this.month_off_set--;
      }
    },
    handleSelectedEmployee(employee_id){
      this.employee_id = employee_id
    },
    getDashboard(){
      this.loading.dashboard = true
      let params = {
        employee_id: this.employee_id,
        months_ago: this.month_off_set
      }
      Api.SellerDashboard.index(params).then((res)=>{
        this.seller_dashboard = [...res.data]
      }).finally(()=>{
        this.loading.dashboard = false
        this.setData()
      })
    },
    getModalities(){
      this.loading.modalities = true
      this.modalities = []
      Api.Modality.index({employee_id: this.employee_id}).then((res)=>{
        this.modalities = [...res.data.sort(this.orderByName)]
      }).finally(()=>{
        this.loading.modalities = false
        this.setHeaders()
      })
    },
    setHeaders(){
      let modalities_headers = []
      this.modalities.forEach( modality => {
        modalities_headers.push({ text: modality.name, align: "center", value: String(modality.id)})
      })
      this.headers = [
        { text: 'Dia', align: "center", value: "day"},
        ...modalities_headers,
        { text: 'Total', align: "center", value: "total"},
      ]
    },
    setData(){
      this.data = []
      this.seller_dashboard.forEach( day_info => {
        let object = { day: day_info.day}
        this.modalities.forEach( modality => {
          object[modality.id] = day_info[modality.id] || 0
        })
        object.total = day_info.total
        this.data.push(object)
      })
      this.calculeTotalRow()
    },
    calculeTotalRow(){
      const nonSummableColumns = ['day'];
      const totalRowDynamic = this.data.reduce((accumulator, currentLine) => {
        for (const key in currentLine) {
          if (!nonSummableColumns.includes(key)) {
            // Converte o valor para número com parseFloat() antes de somar
            const currentValue = parseFloat(currentLine[key]);
            // Verifica se o valor é um número válido antes de somar
            if (!isNaN(currentValue)) {
              accumulator[key] = (accumulator[key] || 0) + currentValue;
            }
          }
        }
        return accumulator;
      }, { day: 'Total' });

      for (const key in totalRowDynamic) {
        if (typeof totalRowDynamic[key] === 'number') {
          totalRowDynamic[key] = parseFloat(totalRowDynamic[key].toFixed(2));
        }
      }

      console.log(totalRowDynamic);
      this.data.push(totalRowDynamic);
    },
    orderByName(a, b){
      const nameA = a.name.toUpperCase();
      const nameB = b.name.toUpperCase();
      if (nameA < nameB) {
        return -1;
      }if (nameA > nameB) {
        return 1; 
      }
      return 0;
    }
  },
  watch:{
    employee_id(){
      this.getData()
    },
    month_off_set(){
      this.getData()
    },
  },
  mounted () {
    this.getData()
  },
}
</script>
